export const colorPaletteMappings = {
    white: {
        base: { color: 'white', variant: 'base', value: '#FFFFFF', opacity: 1 },
    },
    gray: {
        10: { color: 'gray', variant: '10', value: '#F6F8FA', opacity: 1 },
        20: { color: 'gray', variant: '20', value: '#EAEDF2', opacity: 1 },
        30: { color: 'gray', variant: '30', value: '#DBDFE7', opacity: 1 },
        40: { color: 'gray', variant: '40', value: '#C0C6CF', opacity: 1 },
        50: { color: 'gray', variant: '50', value: '#A5ACB9', opacity: 1 },
        60: { color: 'gray', variant: '60', value: '#777E8B', opacity: 1 },
        70: { color: 'gray', variant: '70', value: '#4A515E', opacity: 1 },
        80: { color: 'gray', variant: '80', value: '#323946', opacity: 1 },
        90: { color: 'gray', variant: '90', value: '#1D232F', opacity: 1 },
        100: { color: 'gray', variant: '100', value: '#000000', opacity: 1 },
    },
    red: {
        10: { color: 'red', variant: '10', value: '#FFF0F0', opacity: 1 },
        20: { color: 'red', variant: '20', value: '#FFEBEC', opacity: 1 },
        30: { color: 'red', variant: '30', value: '#FCD4D7', opacity: 1 },
        40: { color: 'red', variant: '40', value: '#F9B3B9', opacity: 1 },
        50: { color: 'red', variant: '50', value: '#F47E89', opacity: 1 },
        60: { color: 'red', variant: '60', value: '#E22B3D', opacity: 1 },
        70: { color: 'red', variant: '70', value: '#B6313E', opacity: 1 },
        80: { color: 'red', variant: '80', value: '#721F27', opacity: 1 },
        90: { color: 'red', variant: '90', value: '#3D090E', opacity: 1 },
        100: { color: 'red', variant: '100', value: '#1F0003', opacity: 1 },
    },
    purple: {
        10: { color: 'purple', variant: '10', value: '#F7F5FF', opacity: 1 },
        20: { color: 'purple', variant: '20', value: '#F0EBFF', opacity: 1 },
        30: { color: 'purple', variant: '30', value: '#E3D9FC', opacity: 1 },
        40: { color: 'purple', variant: '40', value: '#D1C0FB', opacity: 1 },
        50: { color: 'purple', variant: '50', value: '#B094F8', opacity: 1 },
        60: { color: 'purple', variant: '60', value: '#8C62F5', opacity: 1 },
        70: { color: 'purple', variant: '70', value: '#6A4ABA', opacity: 1 },
        80: { color: 'purple', variant: '80', value: '#422E75', opacity: 1 },
        90: { color: 'purple', variant: '90', value: '#210F4F', opacity: 1 },
        100: { color: 'purple', variant: '100', value: '#0E0033', opacity: 1 },
    },
    blue: {
        10: { color: 'blue', variant: '10', value: '#F2F7FF', opacity: 1 },
        20: { color: 'blue', variant: '20', value: '#E6EDFA', opacity: 1 },
        30: { color: 'blue', variant: '30', value: '#CEDCF5', opacity: 1 },
        40: { color: 'blue', variant: '40', value: '#ABC7F9', opacity: 1 },
        50: { color: 'blue', variant: '50', value: '#71A1F4', opacity: 1 },
        60: { color: 'blue', variant: '60', value: '#2770EF', opacity: 1 },
        70: { color: 'blue', variant: '70', value: '#2359B6', opacity: 1 },
        80: { color: 'blue', variant: '80', value: '#163772', opacity: 1 },
        90: { color: 'blue', variant: '90', value: '#082559', opacity: 1 },
        100: { color: 'blue', variant: '100', value: '#001740', opacity: 1 },
    },
    teal: {
        10: { color: 'teal', variant: '10', value: '#EDFDFF', opacity: 1 },
        20: { color: 'teal', variant: '20', value: '#E1F7FA', opacity: 1 },
        30: { color: 'teal', variant: '30', value: '#C9F0F5', opacity: 1 },
        40: { color: 'teal', variant: '40', value: '#B5ECF2', opacity: 1 },
        50: { color: 'teal', variant: '50', value: '#82DFE9', opacity: 1 },
        60: { color: 'teal', variant: '60', value: '#48D1E0', opacity: 1 },
        70: { color: 'teal', variant: '70', value: '#369FAA', opacity: 1 },
        80: { color: 'teal', variant: '80', value: '#22636B', opacity: 1 },
        90: { color: 'teal', variant: '90', value: '#0C3F45', opacity: 1 },
        100: { color: 'teal', variant: '100', value: '#002D33', opacity: 1 },
    },
    yellow: {
        10: { color: 'yellow', variant: '10', value: '#FFFBF0', opacity: 1 },
        20: { color: 'yellow', variant: '20', value: '#FFF8E5', opacity: 1 },
        30: { color: 'yellow', variant: '30', value: '#FCF1D1', opacity: 1 },
        40: { color: 'yellow', variant: '40', value: '#FDE9AF', opacity: 1 },
        50: { color: 'yellow', variant: '50', value: '#FCD977', opacity: 1 },
        60: { color: 'yellow', variant: '60', value: '#FCC838', opacity: 1 },
        70: { color: 'yellow', variant: '70', value: '#BF982A', opacity: 1 },
        80: { color: 'yellow', variant: '80', value: '#785F1A', opacity: 1 },
        90: { color: 'yellow', variant: '90', value: '#4F3D09', opacity: 1 },
        100: { color: 'yellow', variant: '100', value: '#2E2200', opacity: 1 },
    },
    green: {
        10: { color: 'green', variant: '10', value: '#EDFFF9', opacity: 1 },
        20: { color: 'green', variant: '20', value: '#E1FAF1', opacity: 1 },
        30: { color: 'green', variant: '30', value: '#C7F2E3', opacity: 1 },
        40: { color: 'green', variant: '40', value: '#9BE5CB', opacity: 1 },
        50: { color: 'green', variant: '50', value: '#56D3A8', opacity: 1 },
        60: { color: 'green', variant: '60', value: '#06BF7F', opacity: 1 },
        70: { color: 'green', variant: '70', value: '#049160', opacity: 1 },
        80: { color: 'green', variant: '80', value: '#025B3C', opacity: 1 },
        90: { color: 'green', variant: '90', value: '#003B26', opacity: 1 },
        100: { color: 'green', variant: '100', value: '#001F14', opacity: 1 },
    },
    orange: {
        10: { color: 'orange', variant: '10', value: '#FFF5F0', opacity: 1 },
        20: { color: 'orange', variant: '20', value: '#FFEEE5', opacity: 1 },
        30: { color: 'orange', variant: '30', value: '#FFDDCC', opacity: 1 },
        40: { color: 'orange', variant: '40', value: '#FFCCB3', opacity: 1 },
        50: { color: 'orange', variant: '50', value: '#FFA97E', opacity: 1 },
        60: { color: 'orange', variant: '60', value: '#FF8142', opacity: 1 },
        70: { color: 'orange', variant: '70', value: '#C26232', opacity: 1 },
        80: { color: 'orange', variant: '80', value: '#7A3D1F', opacity: 1 },
        90: { color: 'orange', variant: '90', value: '#471F0B', opacity: 1 },
        100: { color: 'orange', variant: '100', value: '#331100', opacity: 1 },
    },
};
export const systemColors = {
    background: {
        background: {
            color: 'background',
            variant: 'background',
            value: colorPaletteMappings.gray['10'].value,
            opacity: 1,
        },
        surface: {
            color: 'background',
            variant: 'surface',
            value: colorPaletteMappings.white.base.value,
            opacity: 1,
        },
    },
    text: {
        default: {
            color: 'text',
            variant: 'default',
            value: colorPaletteMappings.gray['90'].value,
            opacity: 1,
        },
        info: {
            color: 'text',
            variant: 'info',
            value: colorPaletteMappings.gray['60'].value,
            opacity: 1,
        },
        alternate: {
            color: 'text',
            variant: 'alternate',
            value: colorPaletteMappings.white.base.value,
            opacity: 1,
        },
    },
    divider: {
        'on-dark-bg': {
            color: 'divider',
            variant: 'on-dark-bg',
            value: colorPaletteMappings.gray['60'].value,
            opacity: 1,
        },
        'on-light-bg': {
            color: 'divider',
            variant: 'on-light-bg',
            value: colorPaletteMappings.gray['20'].value,
            opacity: 1,
        },
    },
    outline: {
        base: {
            color: 'outline',
            variant: 'base',
            value: colorPaletteMappings.gray['40'].value,
            opacity: 1,
        },
    },
    primary: {
        base: {
            color: 'primary',
            variant: 'base',
            value: colorPaletteMappings.blue['60'].value,
            opacity: 1,
        },
    },
    semantic: {
        failure: {
            color: 'semantic',
            variant: 'failure',
            value: colorPaletteMappings.red['60'].value,
            opacity: 1,
        },
        'failure-bg': {
            color: 'semantic',
            variant: 'failure-bg',
            value: colorPaletteMappings.red['20'].value,
            opacity: 1,
        },
        warning: {
            color: 'semantic',
            variant: 'warning',
            value: colorPaletteMappings.yellow['60'].value,
            opacity: 1,
        },
        'warning-bg': {
            color: 'semantic',
            variant: 'warning-bg',
            value: colorPaletteMappings.yellow['20'].value,
            opacity: 1,
        },
        success: {
            color: 'semantic',
            variant: 'success',
            value: colorPaletteMappings.green['60'].value,
            opacity: 1,
        },
        'success-bg': {
            color: 'semantic',
            variant: 'success-bg',
            value: colorPaletteMappings.green['20'].value,
            opacity: 1,
        },
        info: {
            color: 'semantic',
            variant: 'info',
            value: colorPaletteMappings.blue['60'].value,
            opacity: 1,
        },
        'info-bg': {
            color: 'semantic',
            variant: 'info-bg',
            value: colorPaletteMappings.blue['20'].value,
            opacity: 1,
        },
    },
    'list-state': {
        hover: {
            color: 'list-state',
            variant: 'hover',
            value: colorPaletteMappings.gray['40'].value,
            opacity: 0.12,
        },
        selected: {
            color: 'list-state',
            variant: 'selected',
            value: colorPaletteMappings.blue['20'].value,
            opacity: 0.12,
        },
    },
};
//# sourceMappingURL=color-constants.js.map